import {
  ActionIcon,
  Button,
  Flex,
  Group,
  Modal,
  Text,
  TextInput,
} from "@mantine/core";
import { memo, useState } from "react";
import { MdClear, MdEdit } from "react-icons/md";
import {
  errorShowNotification,
  successShowNotification,
} from "src/lib/mantine";
import { useUpdateUserLineIdMutation } from "src/service/AdminApi/AdminUsers";

interface LineIdCellProps {
  userId: string;
  currentLineId?: string | null;
  onUpdate?: () => void;
}

const LineIdCell = ({ userId, currentLineId, onUpdate }: LineIdCellProps) => {
  const [lineIdModalOpened, setLineIdModalOpened] = useState(false);
  const [lineIdValue, setLineIdValue] = useState(currentLineId || "");
  const [updateUserLineId, { isLoading: lineIdLoading }] =
    useUpdateUserLineIdMutation();

  const handleUpdateLineId = async () => {
    try {
      await updateUserLineId({
        userId,
        lineId: lineIdValue.trim() || null,
      }).unwrap();
      successShowNotification("LINE IDを更新しました");
      setLineIdModalOpened(false);
      onUpdate?.();
    } catch (error) {
      errorShowNotification("LINE IDの更新に失敗しました");
    }
  };

  const handleClearLineId = async () => {
    try {
      await updateUserLineId({
        userId,
        lineId: null,
      }).unwrap();
      successShowNotification("LINE IDをクリアしました");
      setLineIdValue("");
      onUpdate?.();
    } catch (error) {
      errorShowNotification("LINE IDのクリアに失敗しました");
    }
  };

  const openEditModal = () => {
    setLineIdValue(currentLineId || "");
    setLineIdModalOpened(true);
  };

  return (
    <div>
      <Modal
        opened={lineIdModalOpened}
        onClose={() => setLineIdModalOpened(false)}
        title="LINE ID編集"
        size="md"
      >
        <Flex direction="column" gap="md">
          <TextInput
            label="LINE ID"
            placeholder="LINE IDを入力してください"
            value={lineIdValue}
            onChange={(e) => setLineIdValue(e.currentTarget.value)}
          />
          <Group position="right">
            <Button
              variant="outline"
              onClick={() => setLineIdModalOpened(false)}
              disabled={lineIdLoading}
            >
              キャンセル
            </Button>
            <Button onClick={handleUpdateLineId} loading={lineIdLoading}>
              更新
            </Button>
          </Group>
        </Flex>
      </Modal>

      <Flex align="center" gap="xs">
        <Text
          size="sm"
          lineClamp={1}
          style={{ maxWidth: "120px", wordBreak: "break-all" }}
        >
          {currentLineId || "-"}
        </Text>

        <ActionIcon size="sm" variant="subtle" onClick={openEditModal}>
          <MdEdit size={16} />
        </ActionIcon>

        {currentLineId && (
          <ActionIcon
            size="sm"
            variant="subtle"
            color="red"
            onClick={handleClearLineId}
            loading={lineIdLoading}
          >
            <MdClear size={16} />
          </ActionIcon>
        )}
      </Flex>
    </div>
  );
};

export const LineIdCellMemo = memo(LineIdCell);
